import React from 'react';
import ReactDOM from 'react-dom/client';
import moment from 'moment';

// Patch moment's fallback parser globally to handle custom date formats like DD-MM-YYYY
moment.createFromInputFallback = function (config) {
  const input = config._i;
  if (typeof input === 'string') {
    // 1. Check for DD-MM-YYYY or DD/MM/YYYY with optional time
    const matchDMY = input.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/);
    if (matchDMY) {
      const day = parseInt(matchDMY[1], 10);
      const month = parseInt(matchDMY[2], 10) - 1; // 0-indexed
      const year = parseInt(matchDMY[3], 10);
      const hour = matchDMY[4] ? parseInt(matchDMY[4], 10) : 0;
      const minute = matchDMY[5] ? parseInt(matchDMY[5], 10) : 0;
      const second = matchDMY[6] ? parseInt(matchDMY[6], 10) : 0;
      config._d = new Date(year, month, day, hour, minute, second);
      config._isValid = true;
      return;
    }

    // 2. Check for YYYY-MM-DD or YYYY/MM/DD with optional time
    const matchYMD = input.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/);
    if (matchYMD) {
      const year = parseInt(matchYMD[1], 10);
      const month = parseInt(matchYMD[2], 10) - 1; // 0-indexed
      const day = parseInt(matchYMD[3], 10);
      const hour = matchYMD[4] ? parseInt(matchYMD[4], 10) : 0;
      const minute = matchYMD[5] ? parseInt(matchYMD[5], 10) : 0;
      const second = matchYMD[6] ? parseInt(matchYMD[6], 10) : 0;
      config._d = new Date(year, month, day, hour, minute, second);
      config._isValid = true;
      return;
    }
  }
  config._d = new Date(input);
};
import './index.css';
import App from './App';
import 'simplebar/src/simplebar.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { store, persistor } from './store/index';
import { PersistGate } from 'redux-persist/integration/react';
import GlobalDndContext from './utils/dnd-context';
import 'react-circular-progressbar/dist/styles.css';
import { SocketProvider } from './context/SocketContext';
   import { NotificationProvider } from './bmr/contexts/NotificationContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <GlobalDndContext>
    <ReduxProvider store={store}>
      <PersistGate persistor={persistor}>
      <SocketProvider>
          <NotificationProvider>
        <BrowserRouter basename="/" >
            <App />
        </BrowserRouter>
        </NotificationProvider>
      </SocketProvider>
      </PersistGate>
    </ReduxProvider>
  </GlobalDndContext>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
